import { store, getContext, getElement, useState, useEffect } from "@wordpress/interactivity";

const { state, callbacks, actions } = store('frs-blocks/popup', {
  state: {
    popup_elements: {},

    trigger_elements: {},

    Observer: {
      Config: {
        attributes: true,
        childList: false,
        subtree: false
      },

      Stop: function(element){
        state.Observer.Instance.disconnect();
      },

      Start: function(element){
        state.Observer.Instance.observe(element, state.Observer.Config);
      },

      Instance: new MutationObserver(function(changes, observer){
        changes.forEach(function(mutated_element, mutated_element_index){
          if(jQuery('.wp-block-frs-blocks-popup:not(.inactive)').length > 0){
            jQuery('body').addClass('active-popup');
          } else {
            jQuery('body').removeClass('active-popup');
          }
        });
      })
    }
  },

  callbacks: {
    Initialize: function(){
      document.querySelectorAll('.wp-block-frs-blocks-popup:not(.initialized)').forEach(function(popup_element, popup_element_index){
        state.Observer.Start(popup_element);
        popup_element.classList.add('initialized');
      });

      document.querySelectorAll('.wp-block-frs-blocks-popup .close').forEach(function(popup_close_button, popup_close_button_index){
        popup_close_button.addEventListener('click', function(e){
          e.preventDefault();
          callbacks.close(e.target.closest('.wp-block-frs-blocks-popup').getAttribute('id'));
        });
      });

      document.querySelectorAll('a').forEach(function(link, link_index){
        var destination = link.getAttribute('href');

        if(destination.indexOf('#') === 0){
          try {
            destination = new URL(destination);
          } catch(e){
            destination = new URL(window.location.href + destination);
          }

          if(destination.hash){
            var destination_element = document.querySelector(destination.hash);

            if(destination_element && destination_element.classList.contains('wp-block-frs-blocks-popup')){
              link.addEventListener('click', function(e){
                var associated_flow = (link.closest('[data-flow-id]')) ? link.closest('[data-flow-id]') : false;
                var associated_flow_id = associated_flow ? associated_flow.getAttribute('data-flow-id') : false;
                var allow_user_to_proceed = true;

                e.preventDefault();

                if(link.getAttribute('data-validate')){
                  if(associated_flow){
                    associated_flow.querySelectorAll('[data-validate]').forEach(function(control, index){
                      control.dispatchEvent(new CustomEvent('validate'));
                    });

                    if(associated_flow.querySelectorAll('[data-invalid]').length > 0){
                      allow_user_to_proceed = false;
                    }
                  }
                }

                setTimeout(function(){
                  if(allow_user_to_proceed){
                    if(link.getAttribute('data-auto-submit') && (associated_flow)){
                      var perform_auto_submission = true;
                      var associated_form = document.querySelector('[data-flow-id="' + associated_flow_id + '"] .wp-block-frs-blocks-form-embed');

                      if(associated_form){
                        var required_fields = ['FirstName', 'LastName', 'Email', 'Phone', 'Company', 'Title'];
                        var form_entity = MktoForms2.getForm(associated_form.getAttribute('data-form'));
                        var form_data = false;

                        if(form_entity){
                          form_data = form_entity.getValues();
                        } else {
                          perform_auto_submission = false;
                        }

                        required_fields.forEach(function(field, field_index){
                          var field_value = form_data[field];

                          if(!field_value){
                            perform_auto_submission = false;
                          }
                        });
                      }

                      if(perform_auto_submission === true){
                        form_entity.submit();
                      } else {
                        callbacks.open(destination.hash, e.target);
                      }
                    } else {
                      callbacks.open(destination.hash, e.target);
                    }
                  }
                }, 33);
              });
            }
          }
        }
      });

      window.addEventListener('open-popup', function(e){
        var hash = e.detail.id;

        if(e.detail.id.indexOf('#') == -1){
          hash = '#' + e.detail.id;
        }

        callbacks.open(hash);
      });

      window.addEventListener('close-popup', function(e){
        if(e.detail.id.indexOf('#') == -1){
          e.detail.id = '#' + e.detail.id;
        }

        callbacks.close(e.detail.id);
      });

      window.addEventListener("marketo-form-submitted", function(e){
        var associated_flow = e.detail.instance.closest('[data-flow-id]');

        if(associated_flow){
          var associated_flow_id = associated_flow.getAttribute('data-flow-id') ? associated_flow.getAttribute('data-flow-id') : false;
          var confirmation_screen = document.querySelector('[data-flow-id="' + associated_flow_id + '"][data-confirmation-screen="' + true + '"]');

          callbacks.open(confirmation_screen.getAttribute('id'), false);
        }
      });
    },

    open: function(selector, trigger_element){
      var hash = selector;

      if(selector.indexOf('#') == -1){
        hash = '#' + selector;
      }

      var popup_element = document.querySelector(hash);
      var associated_flow = false;

      if(popup_element.getAttribute('data-flow-id')){
        associated_flow = popup_element.getAttribute('data-flow-id');
      }

      if(associated_flow){
        var related_form = popup_element.querySelector('.wp-block-frs-blocks-form-embed');

        if(related_form){
          var form_id = related_form.getAttribute('data-form');
          var form_instance = MktoForms2.getForm(form_id);

          if(related_form.getAttribute('data-submitted')){
            window.dispatchEvent(new CustomEvent('marketo-form-reset', {
              detail: {
                id: form_id
              }
            }));
          }

          setTimeout(function(){
            if(state.flows[associated_flow].name){
              form_instance.setValues({
                'cPECourseName': state.flows[associated_flow].name
              });
            }
          }, 33);
        }
      }

      if(trigger_element){
        state.trigger_elements[hash] = trigger_element;
      }

      callbacks.closeAll(hash.replace('#', ''));

      if(popup_element){
        popup_element.classList.remove('inactive');

        if(state.popup_elements[hash]){
          clearTimeout(state.popup_elements[hash]);
        }

        state.popup_elements[hash] = setTimeout(function(){
          popup_element.focus();
        }, 33);
      }
    },

    closeAll: function(exclusion){
      document.querySelectorAll('.wp-block-frs-blocks-popup').forEach(function(popup, popup_index){
        var popup_id = popup.getAttribute('id');

        if((!exclusion) || (exclusion != popup_id)){
          callbacks.close(popup_id);
        }
      });
    },

    close: function(popup_id){
      var popup_element = document.querySelector('#' + popup_id);
      var popup_element_href = '#' + popup_element.getAttribute('id');
      var return_element = false;

      if(state.trigger_elements[popup_element_href]){
        return_element = state.trigger_elements[popup_element_href];
      }

      if(popup_element){
        popup_element.classList.add('inactive');
      }

      if(return_element){
        if(state.popup_elements[popup_element_href]){
          clearTimeout(state.popup_elements[popup_element_href]);
        }

        state[popup_element_href] = setTimeout(function(){
          return_element.focus();
        }, 33);
      }
    }
  }
});

callbacks.Initialize();
